/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

import { fetchGet } from 'FetchAPIs';
import { I18NError } from 'Utils';

const messages = defineMessages({
  errorGettingPlatformRoles: 'Unable to retrieve user roles. {message}',
});

export const getPlatformUserRoles = async () => {
  try {
    const { roles } = await fetchGet(`/api/platform/authorization/roles`);
    if (!Array.isArray(roles)) {
      throw new Error('No roles found.');
    }
    return roles.filter(({ roleTypes }) => roleTypes.includes('User'));
  } catch (error) {
    throw new I18NError(messages.errorGettingPlatformRoles, error.response || error);
  }
};
